import React, { Component } from 'react';
import NavTools from '../../tools/NavTools';
import LocalStorage from '../../local-storage/LocalStorage';
import fb_db from '../../firebase/firebaseUse';
import SoundRepository from '../../game/handlers/SoundRepository'
import Constants from '../../game/constants/Constants'
import './HomePage.css';
import '../General.css'
import MuteButton from '../../small-components/mute-button/MuteButton';

class HomePage extends Component {
    static START_COMPUTER_GAME_TIMEOUT = 50;

    constructor(props) {
        super(props);

        this.localStorage = LocalStorage.getAllStorage();

        this.state = {
            selectedBtn: -1,
            Menu: null,
            name: {
                val: this.localStorage.name,
                valid: null
            },
            schoolName: {
                val: this.localStorage.schoolName,
                valid: null
            },
            grade: {
                val: this.localStorage.grade,
                valid: null
            }
        }

        this.soundRepository = SoundRepository;
    }

    componentDidMount() {
        this.soundRepository.playSoundByName(Constants.SOUND_HOME_PAGE);
    }

    componentWillUnmount() {
        this.soundRepository.stopSoundByName(Constants.SOUND_HOME_PAGE);
    }

    editingMode = (event, field) => {
        this.setState({ [field]: { ...this.state[field], val: event.target.value } });
    }

    btnStyle = () => {
        // let backgroundImage = require("../../media/images/icons/pink-btn.png");
        let cb = () => {
            setTimeout(() => {
                NavTools.redirect(this.props, `/menu`, {});
            }, HomePage.START_COMPUTER_GAME_TIMEOUT);
        }
        this.setState({
            Menu: {
                border: 'none',
                // backgroundImage: `url(${backgroundImage})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "center",
                backgroundSize: "100% 100%",
                color: "white"
            }

        }, cb);
    }

    handleSignInClick = () => {
        this.soundRepository.playSoundByName(Constants.SOUND_BUTTON);

        let regexSchoolName = /^[\u0590-\u05FF ]+$/;
        let regexName = /^[\u0590-\u05FF ]* [\u0590-\u05FF ]*/; // needs to be at least two words
        let regexClass = /[\u0590-\u05FF0-9 ]+$/;

        let currState = this.state
        let newState = {};


        newState.name = {
            val: currState.name.val,
            valid: currState.name.val === "test user" || regexName.test(currState.name.val)
        }
        newState.schoolName = {
            val: currState.schoolName.val,
            valid: currState.schoolName.val === "test school" ||regexSchoolName.test(currState.schoolName.val)
        }
        newState.grade = {
            val: currState.grade.val,
            valid: regexClass.test(currState.grade.val)
        }

        this.setState({ ...newState });

        if (newState.name.valid && newState.schoolName.valid && newState.grade.valid) {

            let valuStr = `${newState.name.val}-${newState.schoolName.val}-${newState.grade.val}`;

            if (this.localStorage.lid && this.localStorage.name === newState.name.val && this.localStorage.grade === newState.grade.val && this.localStorage.schoolName === newState.schoolName.val) { //in case the curr user is already registrated
                LocalStorage.setStudentData(newState.name.val, newState.schoolName.val, newState.grade.val, this.localStorage.cid)
            } else { // if it not a registrated user or a registrated usr from a different computer
                (async () => {
                    let dataExists = await fb_db.checkIfDetailsExists(valuStr)
                    if (dataExists) { //if there is a user as such
                        let id = Object.keys(dataExists)[0].toString();
                        let currScore = await fb_db.getDataFromFB("users/" + id + "/score/")
                        LocalStorage.setStudentData(newState.name.val, newState.schoolName.val, newState.grade.val, id, currScore.node_.value_)
                    } else { //if it's a totally new user
                        let userId_fb = fb_db.pushDataTofirebaseApp(
                            "users/",
                            {
                                name: newState.name.val,
                                schoolName: newState.schoolName.val,
                                grade: newState.grade.val,
                                details: valuStr,
                                score: 0
                            }
                        );

                        LocalStorage.setStudentData(newState.name.val, newState.schoolName.val, newState.grade.val, userId_fb.key, 0)
                    }
                })()
            }
            this.btnStyle()

        } else {
            return;
        }
    }

    handleChampionsClick = () => {
        this.soundRepository.playSoundByName(Constants.SOUND_BUTTON);
        NavTools.redirect(this.props, '/champions', { prevUrl: '/' });
    }

    render() {
        return (
            <div className="home-page page">
                <img
                    alt="home_pic"
                    id="logo"
                    src={require('../../media/images/icons/logo.png')}
                    draggable="false" />

                <MuteButton />

                <div className="flex-parent-btn">
                    <div className="text-input-flex">
                        <div className="input-title">שם מלא</div>
                        <input type="text" className="input-frame" value={this.state.name.val} onChange={(e) => this.editingMode(e, "name")} />
                        <div className="warning-message" style={this.state.name.valid === false ? null : { visibility: "hidden" }}>שם משתמש לא תקין</div>
                    </div>

                    <div className="text-input-flex">
                        <div className="input-title">בית ספר</div>
                        <input type="text" className="input-frame" value={this.state.schoolName.val} onChange={(e) => this.editingMode(e, "schoolName")} />
                        <div className="warning-message" style={this.state.schoolName.valid === false ? null : { visibility: "hidden" }}>שם ביה"ס לא תקין</div>
                    </div>

                    <div className="text-input-flex">
                        <div className="input-title">כיתה</div>
                        <input type="text" className="input-frame" value={this.state.grade.val} onChange={(e) => this.editingMode(e, "grade")} />
                        <div className="warning-message" style={this.state.grade.valid === false ? null : { visibility: "hidden" }}>שם כיתה לא תקין</div>
                    </div>

                    <button
                        id="sign-up"
                        style={this.state.Menu}
                        onClick={this.handleSignInClick}>
                        כניסה
                    </button>

                </div>

                <div id="nav-bar">
                    <img
                        alt="home_pic"
                        id="champions"
                        className="nav-bar-item"
                        src={require('../../media/images/icons/champions.png')}
                        onClick={this.handleChampionsClick}
                        draggable="false" />
                </div>

            </div>
        );
    }
}

export default HomePage;